module.exports = __webpack_public_path__ + "static/media/ic_wlb.ad422d7d.svg";